import { createReducer, on } from '@ngrx/store';
import { initialState } from '../auth.state';

import * as actions from './verification.actions';

export const authVerificationReducer = createReducer(
  initialState,

  on(actions.RequestGetVerificationFlow, (state) => ({
    ...state,
    loading: true,
  })),
  on(actions.SuccessGetVerificationFlow, (state, { flow }) => ({
    ...state,
    loading: false,
    verificationFlow: flow,
  })),
  on(actions.RequestUpdateVerificationFlow, (state) => ({
    ...state,
    loading: true,
  })),
  on(actions.SuccessUpdateVerificationFlow, (state) => ({
    ...state,
    loading: false,
  })),

  on(actions.FailUpdateVerificationFlow, (state, { response }) => ({
    ...state,
    loading: false,
    verificationFlow: response,
  }))
);
